import { isArray } from 'underscore';

import {
  WEBSITE_SOURCE_DATA_KEY_MAPPING,
  getWebsiteSourceDataByKey,
} from '@bingads-webui-campaign-react/smart-component-util';

import { convertModelToConfig } from './data-config';

const componentKey = WEBSITE_SOURCE_DATA_KEY_MAPPING.Reviews;

export const proxyReadReviewsComponentConfig = (siteConfig) => {
  const componentConfig = getWebsiteSourceDataByKey(siteConfig, componentKey);
  const reviews = isArray(componentConfig) ? componentConfig : [];

  return reviews.map(convertModelToConfig);
};
